<template>
  <div>
    <main-header />
    <Error :err-code="error.statusCode" :text="error.message" />
    <main-footer />
  </div>
</template>

<script>
import Header from '~/components/Header'
import Footer from '~/components/Footer'
import Error from '../components/Error'

export default {
  components: {
    'main-header': Header,
    'main-footer': Footer,
    Error
  },
  layout: 'empty',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  head() {
    const title =
      this.error.statusCode === 404
        ? this.$t("brand.name") + ' - ' + this.pageNotFound
        : this.$t("brand.name") + ' - ' + this.otherError
    return {
      title,
      meta: [
        { name: 'robots', content: 'noindex, nofollow', hid: 'robots' }
      ]
    }
  },
  data() {
    return {
      pageNotFound: 'Not Found',
      otherError: 'An error occurred'
    }
  }
}
</script>
